export const accountTabs = () => {
  const tabs = document.querySelector("[data-wm-tab]");

  if (!tabs) {
    return;
  }

  const tabButtons = [...tabs.querySelectorAll("[data-wm-tab-button]")];
  const tabSections = [...document.querySelectorAll("[data-wm-tab-section]")];

  const toggleTab = (event) => {
    const activeTabSection = event.currentTarget.dataset.wmTabButton;

    tabButtons.forEach((button) => {
      button.classList.toggle(
        "active",
        button.dataset.wmTabButton === activeTabSection
      );
    });

    tabSections.forEach((section) => {
      section.hidden = section.dataset.wmTabSection !== activeTabSection;
    });
  };

  tabButtons.forEach((button) => {
    button.addEventListener("click", toggleTab);
  });
};
